import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicComponent } from './public/public.component';
import { PrivateComponent } from './private/private.component';
import { HomeComponent } from './public/home/home.component';
import { LoginComponent } from './public/login/login.component';
import { OutletSelectionComponent } from './private/outlet-selection/outlet-selection.component';
import { OutletManagerComponent } from './private/outlet-manager/outlet-manager.component';
import { UserManagementComponent } from './private/outlet-manager/user-management/user-management.component';
import { CashierComponent } from './private/cashier/cashier.component';
import { ReceiptsComponent } from './private/cashier/receipts/receipts.component';
import { CreateEditReceiptComponent } from './private/cashier/receipts/create-edit-receipt/create-edit-receipt.component';
import { BranchManagementComponent } from './private/outlet-manager/branch-management/branch-management.component';
import { OperationsComponent } from './private/operations/operations.component';
import { WarehouseManagementComponent } from './private/operations/warehouse-management/warehouse-management.component';
import { RateCalculatorComponent } from './private/cashier/rate-calculator/rate-calculator.component';
import { InventoryComponent } from './private/operations/inventory/inventory.component';
import { AddEditUserComponent } from './private/outlet-manager/user-management/add-edit-user/add-edit-user.component';
import { SearchReceiptComponent } from './private/cashier/receipts/search-receipt/search-receipt.component';
import { CashoutComponent } from './private/cashier/cashout/cashout.component';
import { SettingsComponent } from './private/settings/settings.component';
import { ScannerSettingsComponent } from './private/settings/scanner-settings/scanner-settings.component';
import { AuthGuard } from './services/auth-guard.service';
import { RedirectManagerComponent } from './private/redirect-manager/redirect-manager.component';
import { UnauthorizedComponent } from './public/unauthorized/unauthorized.component';
import { DashboardComponent } from './private/dashboard/dashboard.component';
import { BarcodeReaderComponent } from './private/dashboard/barcode-reader/barcode-reader.component';
import { ShipmentReceivingComponent } from './private/operations/shipment-receiving/shipment-receiving.component';
import { JobsHandoverComponent } from './private/operations/jobs-handover/jobs-handover.component';
import { ReceivingsComponent } from './private/operations/receivings/receivings.component';
import { TopazSettingsComponent } from './private/settings/topaz-settings/topaz-settings.component';
import { MfaComponent } from './private/mfa/mfa.component';


const routes: Routes = [
  { path: "dashboard/s/:username", component: PrivateComponent }, {
    path: "", component: PublicComponent, children: [
      //{ path: "", component: HomeComponent },
      //{ path: "login", component: LoginComponent },
      { path: "", component: LoginComponent },
      { path: "login", component: LoginComponent },
      { path: "unauthorized", component: UnauthorizedComponent },
      { path: "redirect/:page/:branch", component: RedirectManagerComponent }
    ]
  }, {
    path: "dashboard", component: PrivateComponent, children:
      [
        {
          path: "",
          component: DashboardComponent
        },
        {
          path: "outlet-selection",
          component: OutletSelectionComponent,
        },
        {
          path: "confirm-using-qr-code",
          component: BarcodeReaderComponent,
        },
        {
          path: "outlet-manager", component: OutletManagerComponent, canActivate: [AuthGuard], children:
            [

              { path: "user-management", component: UserManagementComponent },
              { path: "branch-management", component: BranchManagementComponent },
              { path: "user-management/add", component: AddEditUserComponent }
            ]
        },
        {
          path: "cashier", component: CashierComponent, canActivate: [AuthGuard], children:
            [
              {
                path: "receipts", component: ReceiptsComponent,
                children: [
                  { path: "create", component: CreateEditReceiptComponent },
                  { path: "", component: SearchReceiptComponent }
                ]
              },
              { path: "rate-calculator", component: RateCalculatorComponent },
              { path: "cashout", component: CashoutComponent }
            ]
        },
        {
          path: "operations", component: OperationsComponent, canActivate: [AuthGuard]
          , children: [
            { path: "jobs-handover", component: JobsHandoverComponent },
            { path: "receivings", component: ReceivingsComponent },
            { path: "shipments-receiving", component: ShipmentReceivingComponent }
            //  { path: "warehouse-management", component: WarehouseManagementComponent },
            // { path: "operations/shipment-receiving", component: ShipmentReceivingComponent },
            //  { path: "inventory", component: InventoryComponent }


          ]
        },
        {
          path: "settings", children: [
            { path: "printer-settings", component: SettingsComponent },
            { path: "scanner-settings", component: ScannerSettingsComponent },
            { path: "topaz-settings", component: TopazSettingsComponent }
          ]
        },

        { path: "mfa", component: MfaComponent }

      ]
  }];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
